/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Required_Edit_Patterns_DescriptionInputs */



/**
* | output |
* | --- |
* | "Please enable compliance in settings to edit patterns." |
*
* @param {Compliance_Required_Edit_Patterns_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_required_edit_patterns_description = /** @type {((inputs?: Compliance_Required_Edit_Patterns_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Required_Edit_Patterns_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte aktiviere Compliance in den Einstellungen, um Muster zu bearbeiten.")
	return /** @type {LocalizedString} */ ("Please enable compliance in settings to edit patterns.")
});